import React, {useState, useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';

import * as S from './LoginUI.styles';

import * as C from '../Onboarding/Common.styles';
import OTPBlock from '../UI/OTP/otp';
import ButtonLoader from '../UI/Loader/Loader';
import {sendEvarData} from '@ibibo/analytics';

import {
  mobileCount,
  emailCount,
} from '../../../store/selectors';
import {validations} from '../../../utils/validations';

const LoginUI = ({submitDetails, resendOTP, apiError, sendOTP, isLoading, userMobile, getToken, forgotPasswordLoader, updatePwdSuccessMessage}) => {

  const mobile_count = useSelector(mobileCount);

  const [{country_code, username, password}, setUserPass] = useState({
    country_code: '+91',
    username: userMobile || '',
    password: '',
  });


  const [useOtp, setUseOtp] = useState(false);
  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});


  const [otpSent, setOtpSent] = useState(false);

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    if(username && !otpSent){
      setOtpSent(true);
      sendOTPFn();
    }
  }, []);

  const otpRef = useRef(null);


  const fieldValidators = {
    country_code: {
      field: 'mobilecode',
      fieldName: 'Mobile Code',
      validators: ['required', 'validMobileCode'],
    },
    username: {field: 'mobile', fieldName: 'Username', validators: ['required','userNameValue']},
    password: {field: 'password', fieldName: 'Password', validators: ['required']},
  };

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            countryCode: '+91'
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const onChangeHandler = (field, value) => {
    const data = {
      country_code,
      username,
      password,
    };
    data[field] = value;
    setUserPass(data);
  };

  const sendOTPFn = () => {
    const hasError = validateFields({
      country_code,
      username
    });
    if (!hasError) {
      if (!useOtp) {
        setUseOtp(!useOtp);
        sendOTP({
          username: `${username}`
        });
      } else {
        setUseOtp(!useOtp);
      }
    }
    sendEvarData({
      prop54: !useOtp ? "myPartner|login|password|loginWithOTP" : "myPartner|login|OTP|loginWithPassword"
    }, true)
  };

  const submitLogin = event => {
    event.preventDefault();
    const hasError = validateFields({
      country_code,
      username,
      password: (useOtp ? otpRef.current.value : password),
    });
    if (!hasError) {
      const dataObj = {
        username: `${username}`
      };
      if (useOtp) {
        dataObj.mobile_otp = otpRef.current.value;
      } else {
        dataObj.password = password;
      }
      submitDetails(dataObj);
    }
    sendEvarData({
      prop54: !useOtp ? "myPartner|login|OTP|login" : "myPartner|login|password|login"
    }, true)
  };

  const getForgotPasswordToken = () => {
    const hasError = validateFields({ username });
    if(!hasError) {
      getToken(username)
    }
  }

  let passwordBlock = (
    <C.InputWrapper>
      <C.CommonInputWrap>
        <C.CommonInput
          type="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={event => onChangeHandler('password', event.target.value)}
          hasError={errors['password'] ? true : false}
        />
        <C.ErrorText>{errors['password']}</C.ErrorText>
      </C.CommonInputWrap>
    </C.InputWrapper>
  );

  if (useOtp) {
    passwordBlock = (
      <OTPBlock
        ref={otpRef}
        label="OTP sent successfully"
        subLabel="(Please enter the OTP sent to the above username)"
        otpLength={6}
        type="motp"
        error={errors['password']}
        resendOTP={resendOTP}
        autoFocus={false}
        resendVisible={mobile_count}
      />
    );
  }

  return (
    <C.FormMainWrapper>
      <C.WelcomeHeadText>Login to your account</C.WelcomeHeadText>
      <C.HeadSubText>Type in your username & password to begin!</C.HeadSubText>
      {
        apiErrorMsg ? (
          <C.HeadSubTitleText>
            <C.HeadSubTitleTextSpan>
            {apiErrorMsg}
            </C.HeadSubTitleTextSpan>
          </C.HeadSubTitleText>
        ) : null
      }
      {
        updatePwdSuccessMessage ? (
          <C.HeadSubTitleText>
          <C.HeadSubTitleTextSpan>
           {updatePwdSuccessMessage}
          </C.HeadSubTitleTextSpan>
        </C.HeadSubTitleText>
        ) : null
      }
      <S.MainWrapperLogin>
        <C.FormWrapper onSubmit={submitLogin}>
          <C.UserInfoForm>
            <C.InputWrapper>
              <C.CommonInputWrap>
                <C.CommonInput
                  type="text"
                  name="username"
                  value={username}
                  placeholder="Username (mobile number)"
                  onChange={event => onChangeHandler('username', event.target.value)}
                  hasError={errors['username'] ? true : false}
                />
                <C.ErrorText>{errors['username']}</C.ErrorText>
              </C.CommonInputWrap>
            </C.InputWrapper>
            {passwordBlock}
            {/* <C.ApiErrorText>{apiErrorMsg}</C.ApiErrorText> */}
            <C.ButtonWrapper>
              <C.SignUpBtn type="submit">
                {isLoading ? <ButtonLoader loaderType="button"/> : 'Login'}
              </C.SignUpBtn>
            </C.ButtonWrapper>
            {!useOtp ? (
              forgotPasswordLoader ? (
                <S.ForgotPasswordLoaderContainer>
                  <ButtonLoader loaderType="gstin"/>
                </S.ForgotPasswordLoaderContainer>
              ) : (
                <S.ForgotPasswordBlock> 
                  <S.ForgotPasswordBlockText onClick={() => getForgotPasswordToken()}> 
                    Forgot Password? 
                  </S.ForgotPasswordBlockText> 
                </S.ForgotPasswordBlock> 
              )
            ) : null}
          </C.UserInfoForm>
        </C.FormWrapper>
        <S.DividerWrapper>
          <S.OrWrapper>OR</S.OrWrapper>
        </S.DividerWrapper>
        <S.LoginOtpWrapper>
          <C.SignUpBtn onClick={sendOTPFn}>
            {/* Login With OTP */}
            {!useOtp ? 'Login With OTP' : 'Login With Password'}
          </C.SignUpBtn>
        </S.LoginOtpWrapper>
      </S.MainWrapperLogin>
    </C.FormMainWrapper>
  );
};

export default LoginUI;
